import { render } from "./AppTabNavTab.vue?vue&type=template&id=761faa6e&scoped=true"
import script from "./AppTabNavTab.vue?vue&type=script&lang=js"
export * from "./AppTabNavTab.vue?vue&type=script&lang=js"

import "./AppTabNavTab.vue?vue&type=style&index=0&id=761faa6e&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-761faa6e"]])

export default __exports__